module.exports = __webpack_public_path__ + "static/media/comment-alt-medical.d8ff7e56.svg";